import {
    createSlice
} from "@reduxjs/toolkit";
import {
    getCatalogue , addCatalogue , updateCatalogue, deleteCatalogue
} from "./thunk";
export const initialState = {
    data:[],
    error: "", // for error message
    loading: false,
};

const catalogueSlice = createSlice({
    name: "catalogue",
    initialState,
    // reducers: {
    //     apiError(state, action) {
    //         state.error = action.payload.data;
    //         state.loading = true;
    //         state.isUserLogout = false;
    //         state.errorMsg = true;
    //     },
    //     updateBusinessInfo(state, action) {
    //         if (action.payload.business_type) {
    //             state.works.business_type = action.payload.business_type
    //         }
    //         if (action.payload.gst_in) {
    //             state.works.gst_in = action.payload.gst_in
    //         }
    //         //   state.businessInfo = action.payload
    //         state.loading = false;
    //         state.errorMsg = false;
    //     },

    // },
    extraReducers: (builder) => {
        builder
            .addCase(getCatalogue.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCatalogue.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(getCatalogue.rejected, (state, action) => {
                state.error = action.payload ? action.payload.error : null;
                state.loading = false;
            })
            .addCase(deleteCatalogue.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteCatalogue.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(deleteCatalogue.rejected, (state, action) => {
                state.error = action.payload ? action.payload.error : null;
                state.loading = false;
            })
            .addCase(addCatalogue.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addCatalogue.fulfilled, (state, action) => {
                console.log('fulfilled')
                state.data.push(action.payload);
                state.loading = false;
            })
            .addCase(addCatalogue.rejected, (state, action) => {
                state.error = action.payload ? action.payload.error : action.error.message;
                state.loading = false;
            })
            .addCase(updateCatalogue.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateCatalogue.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(updateCatalogue.rejected, (state, action) => {
                state.error = action.payload ? action.payload.error : null;
                state.loading = false;
            });
    }
});

// export const {
//     updateBusinessInfo
// } = businessInfoSlice.actions

export default catalogueSlice.reducer;